import { InputType } from '@/types';

/**
 * Generate upload area title based on input type and position
 * For mixed types (image + video), uses "Add your image/video" instead of ordinals
 */
const getUploadTitle = ({
  inputType,
  inputCount,
  index,
  allInputs,
}: {
  inputType: InputType;
  inputCount: number;
  index: number;
  allInputs?: Array<{ type: InputType }>;
}): string => {
  const mediaType = inputType === InputType.VIDEO ? 'video' : 'image';

  // Single input
  if (inputCount === 1) {
    return `Add your ${mediaType}`;
  }

  // Check if inputs have mixed types (image + video)
  if (allInputs && allInputs.length > 1) {
    const hasImage = allInputs.some((i) => i.type === InputType.IMAGE);
    const hasVideo = allInputs.some((i) => i.type === InputType.VIDEO);
    const isMixedTypes = hasImage && hasVideo;

    // For mixed types, use "Add your image/video" without ordinals
    if (isMixedTypes) {
      return `Add your ${mediaType}`;
    }
  }

  // Multiple inputs of same type - use ordinal for first 3, then numbers
  const ordinals = ['first', 'second', 'third'];
  if (index < ordinals.length) {
    return `Add ${ordinals[index]} ${mediaType}`;
  }

  // 4th input onwards - use number
  return `Add ${mediaType} ${index + 1}`;
};

export default getUploadTitle;
